import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import cloudReducer from './cloudSlice';
import organizationsReducer from './organizationsSlice';
import entitlementsReducer from './entitlementsSlice';
import aiInsightReducer from './aiInsightSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    cloud: cloudReducer,
    organizations: organizationsReducer,
    entitlements: entitlementsReducer,
    aiInsight: aiInsightReducer
  },
  devTools: process.env.NODE_ENV !== 'production'
});
